import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
import RNPickerSelect from "react-native-picker-select";
import {
  FontAwesome,
  Entypo,
  Ionicons,
  MaterialIcons,
} from "@expo/vector-icons";
const { width, height } = Dimensions.get("window");
export default function dropdown({
  Gender,
  Type,
  Event,
  Venue,
  Host,
  setValue,
  setValueGender,
  informationCountry,
  value,
  result,
  data,
  style,
}) {
  // const [value, setValue] = useState("");
  const placeholder = {
    label: "",
    value: null,
    color: "#9EA0A4",
  };
  const [gender, setGender] = useState([
    { label: "MALE", value: "Male" },
    { label: "FEMALE", value: "Female" },
  ]);
  const [type, setType] = useState([
    { label: "ATHLETE", value: "Athlete" },
    { label: "OFFICIAL", value: "Official" },
  ]);
  const [event, setEvent] = useState(result);
  const [venue, setVenue] = useState([
    { label: "VENUE1", value: "Venue1" },
    { label: "VENUE2", value: "Venue2" },
  ]);
  const [host, setHost] = useState([]);

  React.useEffect(() => {
    if (informationCountry != undefined) {
      setHost(
        informationCountry.map((item) => {
          console.log(item);
          return {
            label: item.country_name,
            value: item.Association[0].association_id,
          };
        })
      );
      setVenue(
        informationCountry.map((item) => {
          console.log(item);

          return {
            label: item.country_name,
            value: item.Association[0].association_id,
          };
        })
      );
    }
  }, []);

  useEffect(() => {
    if (data != undefined) {
      setVenue(data);
    }
  }, []);

  return (
    <RNPickerSelect
      placeholder={placeholder}
      onValueChange={(val) => {
        setValue(val);
      }}
      value={value}
      items={
        (Gender && gender) ||
        (Type && type) ||
        (Event && event) ||
        (Venue && venue) ||
        (Host && host)
      }
      style={{
        inputWeb: {
          width:
            width >= 1280
              ? Event || Host
                ? width * 0.1
                : 144
              : Host && width * 0.35,
          height: Host ? 25 : 29,
          borderWidth: 1,
          borderColor: Host ? "#7F9DBF" : "#2B6AB1",
          color: "#2B6AB1",
          fontFamily: "Prompt",
          fontSize: 12,
          borderRadius: 6,
          paddingLeft: 10,
          marginTop: Venue || Host ? 0 : 18,
          ...style,
        },
        iconContainer: {
          backgroundColor: "#FFF",
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 1,
          borderColor: "#2B6AB1",
          borderTopRightRadius: 6,
          borderBottomRightRadius: 6,
          width: 30,
          height: Host ? 25 : 29,
          marginTop: Venue || Host ? 0 : 18,
          ...style,
        },
      }}
      Icon={() => {
        return (
          <FontAwesome
            name="caret-down"
            size={24}
            color="#2B6AB1"
            style={{ alignSelf: "center" }}
          />
        );
      }}
    />
  );
}
